import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1.5 21.87s4.06-.639 5.282-.446c1.222.192 4.65 1.076 6.675 1.076 2.026 0 4.29-.384 5.643-.446 1.353-.061 3.116-.384 3.313-1.653.197-1.269.115-5.605-.836-7.889-.952-2.283-2.14-4.482-2.485-5.497-.345-1.015-1.017-2.852-2.034-3.614-1.017-.76-2.666-1.96-3.551-1.899-.886.062-2.97.823-2.494 1.523s.837 1.145.837 1.145-1.419.823-.607 1.33c.812.508 1.747 1.4 3.1 1.33 1.353-.069 1.6.131 1.804 1.077.205.946 1.206 6.32.46 8.419",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2 13.62s2.797-.677 4.42-.254c2.658.692 2.592 1.415 3.404 1.415.812 0 2.772-.416 4.601.346a11.323 11.323 0 0 1 3.092 1.952",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.375 4.285a.41.41 0 1 1 .822.002.41.41 0 0 1-.822-.002Zm.412-1.41a1.41 1.41 0 1 0-.002 2.822 1.41 1.41 0 0 0 .002-2.822Zm4.612 1.25a.5.5 0 0 0-1 0c0 .731-.224 1.371-.56 1.817-.337.447-.764.676-1.19.676a.5.5 0 0 0 0 1c.432 0 .858.231 1.193.68.336.45.557 1.094.557 1.827a.5.5 0 0 0 1 0c0-.731.224-1.371.56-1.817.337-.447.764-.676 1.19-.676a.5.5 0 0 0 0-1c-.432 0-.858-.231-1.193-.68-.335-.45-.557-1.094-.557-1.827Zm-.762 2.42c.094-.125.18-.258.259-.399.078.143.164.278.259.404.165.221.356.419.57.583-.21.161-.4.355-.564.572-.094.125-.18.258-.258.399a3.453 3.453 0 0 0-.26-.404 2.973 2.973 0 0 0-.57-.583c.21-.161.4-.355.564-.572Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }